module.exports = function() {
  let showUI = typeof window !== 'undefined'
  if (window && window.NO_UI) {
    showUI = false
  }
  return showUI
}